export default __webpack_public_path__ + "static/1373-2fdd339c3c55e6b704b26df5e074dd44.gif";